
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|1915|5323|7313)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
